module.exports = __webpack_public_path__ + "img/rope-card-houdini.e51e850.jpeg";